module.exports = __webpack_public_path__ + "media/images/country_flags/li-5c210be84b238bd7b9b076941a1f3180.png";